{
  "vitalsEntry": {
    "title": "生命徵象",
    "subtitle": "記錄並檢視生命徵象",
    "printLabel": "列印生命徵象",
    "recordSection": "記錄生命徵象",
    "save": "記錄生命徵象",
    "cancel": "取消",
    "saving": "記錄中...",
    "recordedSuccess": "生命徵象已成功記錄",
    "recordedError": "記錄生命徵象失敗",
    "invalidEncounter": "就診編號無效。",
    "historyTitle": "近期生命徵象",
    "loadingHistory": "正在載入生命徵象...",
    "loadError": "載入生命徵象失敗。",
    "emptyHistory": "本次就診尚未記錄生命徵象。",
    "morseTitle": "Morse 跌倒風險量表",
    "bradenTitle": "Braden 壓瘡風險量表",
    "riskScalesSaved": "風險評分已成功記錄",
    "riskScalesFailed": "生命徵象已儲存，但風險評分記錄失敗"
  },
  "vitals": {
    "systolic": "收縮壓",
    "diastolic": "舒張壓",
    "heartRate": "心率",
    "respiratoryRate": "呼吸速率",
    "temperature": "體溫",
    "oxygenSaturation": "血氧飽和度 (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "疼痛評分",
    "weight": "體重",
    "height": "身高",
    "bmi": "BMI",
    "rangeError": "{{field}}必須介於 {{min}} 與 {{max}} 之間",
    "placeholders": {
      "temperature": "例如：37.0",
      "heartRate": "例如：72",
      "respiratoryRate": "例如：16",
      "oxygenSaturation": "例如：98",
      "systolic": "例如：120",
      "diastolic": "例如：80",
      "weight": "例如：70.5",
      "height": "例如：175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "正常",
    "borderline": "臨界",
    "abnormal": "異常",
    "critical": "危急"
  },
  "tableHeaders": {
    "dateTime": "日期/時間",
    "temperature": "體溫",
    "heartRate": "心率",
    "respiratoryRate": "呼吸",
    "bloodPressure": "血壓",
    "oxygenSaturation": "SpO2",
    "weight": "體重",
    "height": "身高",
    "pain": "疼痛"
  },
  "io": {
    "title": "出入量",
    "addRecord": "新增記錄",
    "addRecordSection": "新增出入量記錄",
    "loading": "正在載入出入量記錄...",
    "loadError": "載入出入量記錄失敗。",
    "empty": "本次就診未記錄出入量。",
    "totals": {
      "intake": "總入量",
      "output": "總出量",
      "balance": "淨平衡",
      "totalsRow": "合計",
      "netLabel": "淨值"
    },
    "negativeWarning": "負平衡 — 請評估體液狀態",
    "columns": {
      "dateTime": "日期/時間",
      "type": "類型",
      "category": "類別",
      "amount": "量 (ml)",
      "notes": "備註"
    },
    "fields": {
      "type": "類型",
      "category": "類別",
      "amount": "量 (ml)",
      "notes": "備註"
    },
    "type": {
      "intake": "入量",
      "output": "出量"
    },
    "categoryPlaceholder": "選擇類別...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "選填備註...",
    "save": "儲存記錄",
    "cancel": "取消",
    "missingValueShort": "--",
    "toast": {
      "added": "出入量記錄已新增",
      "addFailed": "新增出入量記錄失敗",
      "missingFields": "請填寫必填欄位"
    }
  },
  "intake": {
    "oral": "口服",
    "iv": "IV",
    "bloodProducts": "血品",
    "tpn": "TPN",
    "tubeFeeding": "管灌",
    "other": "其他"
  },
  "output": {
    "urine": "尿量",
    "drain": "引流",
    "emesis": "嘔吐物",
    "stool": "糞便",
    "bloodLoss": "失血",
    "ngSuction": "NG 抽吸",
    "other": "其他"
  },
  "wound": {
    "title": "傷口照護記錄",
    "subtitle": "就診 #{{id}} — 結構化傷口評估",
    "newAssessment": "新增傷口評估",
    "dimensionsTitle": "尺寸（公分）",
    "woundBedTitle": "傷口床 (%)",
    "woundBedTotalWarning": "合計：{{total}}%（應為 100%）",
    "woundBedTotalOk": "合計：100%",
    "previousTitle": "既往評估",
    "empty": "本次就診未記錄傷口評估。",
    "invalidEncounter": "就診編號無效。",
    "save": "儲存評估",
    "savedSuccess": "已記錄傷口評估",
    "savedError": "儲存傷口評估失敗",
    "fields": {
      "woundType": "傷口類型",
      "location": "部位",
      "stage": "分期",
      "length": "長",
      "width": "寬",
      "depth": "深",
      "granulation": "肉芽組織",
      "slough": "腐肉",
      "eschar": "焦痂",
      "epithelial": "上皮",
      "drainageType": "滲液類型",
      "drainageAmount": "滲液量",
      "surroundingSkin": "周圍皮膚",
      "treatment": "處置措施",
      "painScore": "疼痛評分 (0-10)",
      "notes": "備註"
    },
    "placeholders": {
      "length": "例如：3.5",
      "width": "例如：2.0",
      "depth": "例如：0.5",
      "treatment": "描述已實施的傷口照護...",
      "notes": "其他觀察..."
    },
    "history": {
      "dimensionsLabel": "尺寸",
      "drainageLabel": "滲液",
      "painLabel": "疼痛",
      "treatmentLabel": "處置"
    },
    "stage": {
      "stage1": "1 期",
      "stage2": "2 期",
      "stage3": "3 期",
      "stage4": "4 期",
      "unstageable": "無法分期",
      "deepTissue": "深層組織損傷",
      "na": "N/A"
    },
    "drainageType": {
      "none": "無",
      "serous": "漿液性",
      "sanguineous": "血性",
      "serosanguineous": "漿血性",
      "purulent": "膿性"
    },
    "drainageAmount": {
      "none": "無",
      "scant": "極少",
      "small": "少量",
      "moderate": "中等量",
      "large": "大量",
      "copious": "極多"
    },
    "woundType": {
      "pressure": "壓力性損傷",
      "surgical": "手術（傷口）",
      "diabetic": "糖尿病潰瘍",
      "venous": "靜脈潰瘍",
      "arterial": "動脈潰瘍",
      "traumatic": "創傷性",
      "skinTear": "皮膚撕裂傷",
      "other": "其他"
    },
    "location": {
      "sacrum": "薦部",
      "coccyx": "尾骨",
      "leftHeel": "左足跟",
      "rightHeel": "右足跟",
      "leftTrochanter": "左轉子",
      "rightTrochanter": "右轉子",
      "abdomen": "腹部",
      "leftLeg": "左腿",
      "rightLeg": "右腿",
      "back": "背部",
      "other": "其他"
    },
    "surroundingSkin": {
      "intact": "完整",
      "erythema": "紅斑",
      "macerated": "浸漬",
      "indurated": "硬結",
      "edematous": "水腫",
      "warm": "發熱",
      "discolored": "變色"
    }
  },
  "carePlan": {
    "title": "照護計畫",
    "addPlan": "新增照護計畫",
    "newPlan": "新建照護計畫",
    "createPlan": "建立計畫",
    "cancel": "取消",
    "empty": "此病人未記錄照護計畫。",
    "emptyGoals": "尚未設定目標。",
    "goals": "目標",
    "addGoal": "新增目標",
    "saving": "儲存中...",
    "loading": "正在載入照護計畫...",
    "loadError": "載入照護計畫失敗。",
    "fields": {
      "title": "標題",
      "startDate": "起始日期",
      "targetDate": "目標日期",
      "description": "描述",
      "target": "目標值"
    },
    "placeholders": {
      "title": "例如：跌倒預防計畫",
      "description": "目標描述",
      "target": "例如：30 天內無跌倒"
    },
    "history": {
      "startLabel": "起始",
      "targetLabel": "目標",
      "goalsLabel": "目標數"
    },
    "status": {
      "active": "進行中",
      "completed": "已完成",
      "cancelled": "已取消"
    },
    "goalStatus": {
      "inProgress": "進行中",
      "achieved": "已達成",
      "notAchieved": "未達成"
    },
    "toast": {
      "planCreated": "已建立照護計畫",
      "planCreateFailed": "建立照護計畫失敗",
      "goalAdded": "已新增目標",
      "goalAddFailed": "新增目標失敗",
      "planValidation": "標題及起始日期為必填項",
      "goalValidation": "描述及目標值為必填項"
    }
  }
}
